import { createRouter, createWebHashHistory } from 'vue-router';
import App from './App.vue';
import Inicio from './components/Inicio.vue';
import {store} from "./store/index.js";
const routes = [
    {
        path: '/',
        name: 'app',
        component: App,
        children: [
            {
                path: '/',
                name: 'dashboard',
                component: Inicio,
                meta: { requiresAuth: true }
            },	
            {
                path: '/equipos',
                name: 'equipos',
                component: () => import('./components/Equipos.vue'),
                meta: { requiresAuth: true }
            },		
            {
                path: '/empleados',
                name: 'empleados',
                component: () => import('./components/Empleados.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/unidades',
                name: 'unidades',
                component: () => import('./components/Unidades.vue'),
                meta: { requiresAuth: true }
            },	
            {
                path: '/referencias',
                name: 'referencias',
                component: () => import('./components/Referencias.vue'),
                meta: { requiresAuth: true }
            },		
            {
                path: '/status',
                name: 'estatus',
                component: () => import('./components/EstatusSegmento.vue'),
                meta: { requiresAuth: true }
            },	
            {
                path: '/reportestelmex',
                name: 'reportestelmex',
                component: () => import('./components/ReportesTelmex.vue'),
                meta: { requiresAuth: true }
            },	
            {
                path: '/documentos',
                name: 'documentos',
                component: () => import('./components/Documentos.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/productos',
                name: 'productos',
                component: () => import('./components/Productos.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/salidascbm2',
                name: 'salidascbm2',
                component: () => import('./components/SalidasProductos.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/mantenimientos',
                name: 'mantenimientos',
                component: () => import('./components/Mantenimientos.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/equiposcomputo',
                name: 'equiposcomputo',
                component: () => import('./components/EquiposComputo.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/capturarapida',
                name: 'capturarapida',
                component: () => import('./components/CapturaRapida.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/directoriounidad',
                name: 'directoriounidad',
                component: () => import('./components/DirectorioUnidad.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/entradasproductos',
                name: 'entradasproductos',
                component: () => import('./components/EntradasProductos.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/mantenimientos',
                name: 'mantenimientos',
                component: () => import('./components/Mantenimientos.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/universo/:tipo?',
                name: 'universo',
                component: () => import('./components/Universo.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/tipos_servicios',
                name: 'tipos_servicios',
                component: () => import('./components/Tipos_servicios.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/tipos_dispositivos',
                name: 'tipos_dispositivos',
                component: () => import('./components/Tipos_dispositivos.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/tipos_medios',
                name: 'tipos_medios',
                component: () => import('./components/Tipos_medios.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/tipos_lineas',
                name: 'tipos_lineas',
                component: () => import('./components/Tipos_lineas.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/tipos_estatus',
                name: 'tipos_estatus',
                component: () => import('./components/Tipos_estatus.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/tipos_fallos',
                name: 'tipos_fallos',
                component: () => import('./components/Tipos_fallos.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/reportes_lineas',
                name: 'reportes_lineas',
                component: () => import('./components/Reportes_lineas.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/tipos_modalidades',
                name: 'tipos_modalidades',
                component: () => import('./components/Tipos_modalidades.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/reportesRemedy/cargaarchivosremedy',
                name: 'cargaarchivosremedy',
                component: () => import('./components/reportesRemedy/CargaArchivosReportesRemedy.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/monitoreoSitios/servidores',
                name: 'servidores',
                component: () => import('./components/monitoreoSitios/Servidores.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/garantias',
                name: 'garantias',
                component: () => import('./components/PNAEC.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/estados',
                name: 'estados',
                component: () => import('./components/catalogos/Estados.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/delegaciones',
                name: 'delegaciones',
                component: () => import('./components/catalogos/Delegaciones.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/catconv',
                name: 'catconv',
                component: () => import('./components/catalogos/CatalogoConversion.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/usuariosubicaciones',
                name: 'usuariosubicaciones',
                component: () => import('./components/catalogos/UsuariosUbicaciones.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/facturacion',
                name: 'facturacion',
                component: () => import('./components/Facturacion.vue'),
                meta: { requiresAuth: true } 
            }, 
            {
                path: '/existencias',
                name: 'existencias',
                component: () => import('./components/Existencias.vue'),
                meta: { requiresAuth: true }
            },
        ]
    },
    
    {
        path: '/login',
        name: 'login',
        component: () => import('./pages/Login.vue')
    },
    {
        path: '/landing',
        name: 'landing',
        component: () => import('./pages/LandingDemo.vue'),
        meta: { requiresAuth: false }

    },
    {
        path: '/error',
        name: 'error',
        component: () => import('./pages/Error.vue')
    },
    {
        path: '/notfound',
        name: 'notfound',
        component: () => import('./pages/NotFound.vue')
    },
    {
        path: '/access',
        name: 'access',
        component: () => import('./pages/Access.vue')
    }
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

router.beforeEach((to, from, next) => {	
	if (to.matched.some(record => record.meta.requiresAuth)) {
		if (!store.getters.getUsuarioLogueado) {
			next({
				path: '/login',
				query: { redirect: to.fullPath }
			})			
		} else {			
			if(to.name == 'edicionrapidaequipos'){
				if(store.getters.getUsuarioLogueado && store.getters.getUsuarioLogueado.Usuario_sistema.Id_rol==1)
				{
					next()
				}
				else{
					next({
						path: from.path						
					})
				}
			}else{
				next()
			}
		}
	} else {
		next()
	}
});

export default router;
